<template>
  <app-settings-alt v-if="valueName == 'app_settings_alt'" />
  <apps v-else-if="valueName == 'apps'" />
  <arrow-back v-else-if="valueName == 'arrow_back'" />
  <arrow-back-ios v-else-if="valueName == 'arrow_back_ios'" />
  <arrow-downward v-else-if="valueName == 'arrow_downward'" />
  <arrow-drop-down v-else-if="valueName == 'arrow_drop_down'" />
  <arrow-drop-down-circle v-else-if="valueName == 'arrow_drop_down_circle'" />
  <arrow-drop-up v-else-if="valueName == 'arrow_drop_up'" />
  <arrow-forward v-else-if="valueName == 'arrow_forward'" />
  <arrow-forward-ios v-else-if="valueName == 'arrow_forward_ios'" />
  <arrow-left v-else-if="valueName == 'arrow_left'" />
  <arrow-right v-else-if="valueName == 'arrow_right'" />
  <arrow-upward v-else-if="valueName == 'arrow_upward'" />
  <campaign v-else-if="valueName == 'campaign'" />
  <cancel v-else-if="valueName == 'cancel'" />
  <check v-else-if="valueName == 'check'" />
  <chevron-left v-else-if="valueName == 'chevron_left'" />
  <chevron-right v-else-if="valueName == 'chevron_right'" />
  <close v-else-if="valueName == 'close'" />
  <double-arrow v-else-if="valueName == 'double_arrow'" />
  <east v-else-if="valueName == 'east'" />
  <expand-less v-else-if="valueName == 'expand_less'" />
  <expand-more v-else-if="valueName == 'expand_more'" />
  <first-page v-else-if="valueName == 'first_page'" />
  <fullscreen v-else-if="valueName == 'fullscreen'" />
  <fullscreen-exit v-else-if="valueName == 'fullscreen_exit'" />
  <home-work v-else-if="valueName == 'home_work'" />
  <last-page v-else-if="valueName == 'last_page'" />
  <legend-toggle v-else-if="valueName == 'legend_toggle'" />
  <ic-menu v-else-if="valueName == 'menu'" />
  <menu-open v-else-if="valueName == 'menu_open'" />
  <more-horiz v-else-if="valueName == 'more_horiz'" />
  <more-vert v-else-if="valueName == 'more_vert'" />
  <north v-else-if="valueName == 'north'" />
  <north-east v-else-if="valueName == 'north_east'" />
  <north-west v-else-if="valueName == 'north_west'" />
  <payments v-else-if="valueName == 'payments'" />
  <refresh v-else-if="valueName == 'refresh'" />
  <south v-else-if="valueName == 'south'" />
  <south-east v-else-if="valueName == 'south_east'" />
  <south-west v-else-if="valueName == 'south_west'" />
  <subdirectory-arrow-left v-else-if="valueName == 'subdirectory_arrow_left'" />
  <subdirectory-arrow-right
    v-else-if="valueName == 'subdirectory_arrow_right'"
  />
  <switch-down v-else-if="valueName == 'switch_down'" />
  <switch-left v-else-if="valueName == 'switch_left'" />
  <switch-right v-else-if="valueName == 'switch_right'" />
  <switch-up v-else-if="valueName == 'switch_up'" />
  <unfold-less v-else-if="valueName == 'unfold_less'" />
  <unfold-more v-else-if="valueName == 'unfold_more'" />
  <west v-else-if="valueName == 'west'" />
</template>

<script>
import AppSettingsAlt from "@/components/Icons/Navigation/AppSettingsAlt";
import Apps from "@/components/Icons/Navigation/Apps";
import ArrowBack from "@/components/Icons/Navigation/ArrowBack";
import ArrowBackIos from "@/components/Icons/Navigation/ArrowBackIos";
import ArrowDownward from "@/components/Icons/Navigation/ArrowDownward";
import ArrowDropDown from "@/components/Icons/Navigation/ArrowDropDown";
import ArrowDropDownCircle from "@/components/Icons/Navigation/ArrowDropDownCircle";
import ArrowDropUp from "@/components/Icons/Navigation/ArrowDropUp";
import ArrowForward from "@/components/Icons/Navigation/ArrowForward";
import ArrowForwardIos from "@/components/Icons/Navigation/ArrowForwardIos";
import ArrowLeft from "@/components/Icons/Navigation/ArrowLeft";
import ArrowRight from "@/components/Icons/Navigation/ArrowRight";
import ArrowUpward from "@/components/Icons/Navigation/ArrowUpward";
import Campaign from "@/components/Icons/Navigation/Campaign";
import Cancel from "@/components/Icons/Navigation/Cancel";
import Check from "@/components/Icons/Navigation/Check";
import ChevronLeft from "@/components/Icons/Navigation/ChevronLeft";
import ChevronRight from "@/components/Icons/Navigation/ChevronRight";
import Close from "@/components/Icons/Navigation/Close";
import DoubleArrow from "@/components/Icons/Navigation/DoubleArrow";
import East from "@/components/Icons/Navigation/East";
import ExpandLess from "@/components/Icons/Navigation/ExpandLess";
import ExpandMore from "@/components/Icons/Navigation/ExpandMore";
import FirstPage from "@/components/Icons/Navigation/FirstPage";
import Fullscreen from "@/components/Icons/Navigation/Fullscreen";
import FullscreenExit from "@/components/Icons/Navigation/FullscreenExit";
import HomeWork from "@/components/Icons/Navigation/HomeWork";
import LastPage from "@/components/Icons/Navigation/LastPage";
import LegendToggle from "@/components/Icons/Navigation/LegendToggle";
import IcMenu from "@/components/Icons/Navigation/IcMenu";
import MenuOpen from "@/components/Icons/Navigation/MenuOpen";
import MoreHoriz from "@/components/Icons/Navigation/MoreHoriz";
import MoreVert from "@/components/Icons/Navigation/MoreVert";
import North from "@/components/Icons/Navigation/North";
import NorthEast from "@/components/Icons/Navigation/NorthEast";
import NorthWest from "@/components/Icons/Navigation/NorthWest";
import Payments from "@/components/Icons/Navigation/Payments";
import Refresh from "@/components/Icons/Navigation/Refresh";
import South from "@/components/Icons/Navigation/South";
import SouthEast from "@/components/Icons/Navigation/SouthEast";
import SouthWest from "@/components/Icons/Navigation/SouthWest";
import SubdirectoryArrowLeft from "@/components/Icons/Navigation/SubdirectoryArrowLeft";
import SubdirectoryArrowRight from "@/components/Icons/Navigation/SubdirectoryArrowRight";
import SwitchDown from "@/components/Icons/Navigation/SwitchDown";
import SwitchLeft from "@/components/Icons/Navigation/SwitchLeft";
import SwitchRight from "@/components/Icons/Navigation/SwitchRight";
import SwitchUp from "@/components/Icons/Navigation/SwitchUp";
import UnfoldLess from "@/components/Icons/Navigation/UnfoldLess";
import UnfoldMore from "@/components/Icons/Navigation/UnfoldMore";
import West from "@/components/Icons/Navigation/West";

export default {
  components: {
    AppSettingsAlt,
    Apps,
    ArrowBack,
    ArrowBackIos,
    ArrowDownward,
    ArrowDropDown,
    ArrowDropDownCircle,
    ArrowDropUp,
    ArrowForward,
    ArrowForwardIos,
    ArrowLeft,
    ArrowRight,
    ArrowUpward,
    Campaign,
    Cancel,
    Check,
    ChevronLeft,
    ChevronRight,
    Close,
    DoubleArrow,
    East,
    ExpandLess,
    ExpandMore,
    FirstPage,
    Fullscreen,
    FullscreenExit,
    HomeWork,
    LastPage,
    LegendToggle,
    IcMenu,
    MenuOpen,
    MoreHoriz,
    MoreVert,
    North,
    NorthEast,
    NorthWest,
    Payments,
    Refresh,
    South,
    SouthEast,
    SouthWest,
    SubdirectoryArrowLeft,
    SubdirectoryArrowRight,
    SwitchDown,
    SwitchLeft,
    SwitchRight,
    SwitchUp,
    UnfoldLess,
    UnfoldMore,
    West,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
